module.exports = __webpack_public_path__ + "static/feature-1-9a525e7530de0788ace8192305225bb3.png";